<template>
    <v-navigation-drawer v-model="showDrawer" app temporary>
        <!-- <v-list-item>
            <v-list-item-avatar>
                <v-img
                    src="https://randomuser.me/api/portraits/men/78.jpg"
                ></v-img>
            </v-list-item-avatar>

            <v-list-item-content>
                <v-list-item-title>John Leider</v-list-item-title>
            </v-list-item-content>
        </v-list-item> -->

        <!-- <v-divider></v-divider> -->

        <!-- <v-list>
            <v-subheader>Menu</v-subheader>
            <v-list-item
                v-for="(menu, i) in menus"
                :key="i"
                link
                :to="`${menu.path}`"
            >
                <v-list-item-icon>
                    <v-icon>{{ menu.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title>{{ menu.title }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>

        <v-divider></v-divider> -->

        <v-list class="mb-16" dense>
            <v-subheader class="justify-center">
                <router-link to="/">
                    <img style="vertical-align: middle" width="156px" src="@/assets/img/marketpett_logo.svg" alt="Home">
                </router-link>
            </v-subheader>

            <v-subheader>{{ $langs.Product.category[$langs.lang] }}</v-subheader>
            <v-list-group v-for="(value, key) in route" :key="key" no-action>
                <template v-slot:activator>
                    <v-list-item-content>
                        <v-list-item-title v-if="key">{{ $langs.Gen[key][$langs.lang] }}</v-list-item-title>
                    </v-list-item-content>
                </template>

                <v-list-item
                    v-for="{ title, path, titleTh } in value"
                    :key="path"
                    class="pl-8"
                    :to="`/${key}/${path}`"
                >
                    <v-list-item-content>
                        <v-list-item-title>{{ $langs.Product.subType[$langs.lang]({ title, titleTh }) }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- ReptTown Animals Category -->
                <template v-if="key === 'animals'">
                    <v-subheader>ReptTown.com</v-subheader>
                    <v-list-item    
                        v-for="{ title, path, titleTh } in RPT_menus"
                        :key="`rpt-${path}`"
                        class="pl-8"
                        :href="`${appRPTUrl}/${key}/${path}`"
                    >
                        <v-list-item-content>
                            <v-list-item-title>{{ $langs.Product.subType[$langs.lang]({ title, titleTh }) }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </template>
            </v-list-group>
            
            <v-list-item to="/stores">
                <v-list-item-content>
                    <v-list-item-title>{{ $langs.Gen.stores[$langs.lang] }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item to="/manual">
                <v-list-item-content>
                    <v-list-item-title class="d-flex">
                        {{ $langs.Gen.manual[$langs.lang] }}
                        <v-icon right small>mdi-book-open-variant</v-icon>
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
import api from "@/services/api"; // "@/services/api"
import { appRPTUrl } from "@/services/constants";

export default {
    props: ["value"],
    data() {
        return {
            menus: [{ title: "Home", path: "/", icon: "home" }],
            RPT_menus: [],
            showDrawer: false,
            route: { loading: [] },

            appRPTUrl: appRPTUrl
        };
    },
    methods: {
        async loadRoute() {
            let route = await this.$store.dispatch("GetRoute");
            if (!route) return;
            this.route = route;
        },
        async loadReptTownCategory() {
            // At Main Product Type (Animals Only)
            let RPT_route = await api.getRPTRoute();
            this.RPT_menus = RPT_route['animals'];
        },
    },
    mounted() {
        this.showDrawer = this.value;
        this.loadRoute();
        this.loadReptTownCategory();
    },
    watch: {
        value() {
            // when opening drawer
            this.showDrawer = this.value;
        },
        showDrawer() {
            // when user close drawer, emit back to v-model
            this.$emit("input", this.showDrawer);
        },
    },
};
</script>

<style>
</style>